type CatalogCache<TList, TDetail> = {
  invalidate: () => void;
  getList: () => TList[] | null;
  setList: (items: TList[]) => void;
  rememberList: (loader: () => Promise<TList[]>) => Promise<TList[]>;
  getDetail: (slug: string) => TDetail | null;
  setDetail: (slug: string, item: TDetail) => void;
};

const CATALOG_CHANGED = 'idcoder-catalog-changed';

export function createPublicCatalogCache<TList, TDetail>(): CatalogCache<TList, TDetail> {
  let publicList: TList[] | null = null;
  let publicListPromise: Promise<TList[]> | null = null;
  const publicDetails = new Map<string, TDetail>();

  const notify = () => {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new Event(CATALOG_CHANGED));
    }
  };

  return {
    invalidate() {
      publicList = null;
      publicListPromise = null;
      publicDetails.clear();
      notify();
    },
    getList() {
      return publicList;
    },
    setList(items) {
      publicList = items;
    },
    rememberList(loader) {
      if (publicList) return Promise.resolve(publicList);
      if (!publicListPromise) {
        publicListPromise = loader()
          .then((items) => {
            publicList = items;
            return items;
          })
          .catch((error) => {
            publicListPromise = null;
            throw error;
          });
      }
      return publicListPromise;
    },
    getDetail(slug) {
      return publicDetails.get(slug.toLowerCase()) || null;
    },
    setDetail(slug, item) {
      publicDetails.set(slug.toLowerCase(), item);
    },
  };
}
